/**
 * 阶段时间段条组件
 *
 * 在甘特图任务条下方显示各阶段的预计时间段
 */

import { cn } from '@/lib/utils'

import { WORKFLOW_STAGE_LABELS, WORKFLOW_STAGE_COLORS } from './types'
import { calculateTaskPosition } from './utils'

import type { StageTimeRange, ZoomLevel, DateRange } from './types'

interface StageTimeRangeBarProps {
  /** 阶段时间段列表 */
  stageTimeRanges: StageTimeRange[]
  /** 缩放级别 */
  zoomLevel: ZoomLevel
  /** 日期范围 */
  dateRange: DateRange
  /** 行高 */
  rowHeight: number
}

export function StageTimeRangeBar({
  stageTimeRanges,
  zoomLevel,
  dateRange,
  rowHeight,
}: StageTimeRangeBarProps) {
  if (!stageTimeRanges || stageTimeRanges.length === 0) {
    return null
  }

  // 阶段条高度（在任务条下方显示）
  const barHeight = 4
  const barTop = rowHeight - barHeight - 2

  return (
    <div className="absolute inset-x-0" style={{ top: barTop, height: barHeight }}>
      {stageTimeRanges.map((range, index) => {
        const position = calculateTaskPosition(
          { startDate: range.startDate, endDate: range.endDate },
          dateRange,
          zoomLevel
        )

        const tooltipText = `${WORKFLOW_STAGE_LABELS[range.stage]}\n${range.startDate} ~ ${range.endDate}\n预估: ${range.estimatedHours}h`

        return (
          <div
            key={`${range.stage}-${index}`}
            title={tooltipText}
            className={cn(
              'absolute rounded-sm opacity-70 hover:opacity-100 transition-opacity cursor-help',
              WORKFLOW_STAGE_COLORS[range.stage]
            )}
            style={{
              left: position.left,
              width: Math.max(position.width, 4),
              height: barHeight,
            }}
          />
        )
      })}
    </div>
  )
}
